import React, { useState, useEffect, Suspense } from 'react';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux'
import PopupListener from '../components/PopupListener';
import { BackgroundTypeEnum } from '../components/base/BackgroundsEnum'
import { CSSTransition } from 'react-transition-group';
import { MainLayout } from "./MainLayout";
import { Route } from 'react-router-dom'
import { Auth } from '../services/Auth';
import StylesHelper from '../services/helpers/StylesHelper';
const NotFound = React.lazy(() => import('../routes/NotFound'));

const GamesFullViewHeader = React.lazy(() => import('../components/header/GamesFullViewHeader'));

export const DemoPages = ['casino', 'casino-lobby', 'tvgames-lobby', 'virtualsport-lobby', 'fastgames-lobby', 'single-game'];
export const MultiViewPages = ['livecasino', 'casino-lobby', 'casino', 'tvgames-lobby', 'virtualsport-lobby', 'fastgames-lobby', 'single-game']

/* GamesFullViewLayout Layout */
export const GamesFullViewLayout = ({ children, matchProps, ...rest }) => {
  const { showAnnouncements } = useSelector(state => state.settings);
  const [isAnnouncementVisible, setAnnuncementVisibility] = useState(showAnnouncements);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const bodyBg = rest.pageBgData && rest.pageBgData.filter(data => data.backgroundType === BackgroundTypeEnum.Body).filter(element => {
    let elementPages = element.pages.filter(el => el.prefix + el.alias === rest.alias)

    return element.forAllPages ? true : elementPages && elementPages.length ? true : false;
  });
  const params = useParams()
  let isSingleGame = rest.page === 'single-game';

  const background = bodyBg && bodyBg[0];
  let mainStyle = {};
  if (background) {
    const bgImg = background.imageUrl ? background.imageUrl : `/img/backgrounds/${background.id}${background.extension}?v=${background.lastModifiedDate}`;
    mainStyle = { backgroundImage: `url("${bgImg}")` };
  }


  useEffect(() => {
    setAnnuncementVisibility(showAnnouncements)
  }, [showAnnouncements]);

  const handleShowMenu = () => {
    setIsShowMenu(!isShowMenu);
  }

  return (
    <React.Fragment>
      <div className={`wrapper ${isShowMenu ? '' : 'multi-view__hidden-menu'}`}>
        <Suspense fallback={<></>}>
          <GamesFullViewHeader hasDemo={rest.hasDemo} page={params?.page} handleShowMenu={handleShowMenu} isShowMenu={isShowMenu} />
        </Suspense>
        <CSSTransition
          in={true}
          appear={true}
          timeout={600}
          classNames="fade"
        >
          {
            <main className={`main-block multi-view_main ${isShowMenu ? 'active' : ''} ${bodyBg && bodyBg.length ? StylesHelper.getBgSize(bodyBg) : ''}`} style={mainStyle}>
              <Suspense fallback={<></>}>
                {children}
              </Suspense>
            </main>
          }
        </CSSTransition>

      </div>
    </React.Fragment>
  )
}

/*
  Multiview route wrapper
 */

export const GamesFullViewRoute = ({ component: Component, isSettingsLoading, language, placeholder: PlaceHolder, alias, pageBgData, ...rest }) => {

  const layouts = {
    multy: GamesFullViewLayout,
    main: MainLayout
  }
  return (
    <Route {...rest} render={matchProps => {
      //for casino alternativ url params name 
      const page = matchProps?.match?.params?.page.replace('multigame', 'casino');
      const isMultivewPage = MultiViewPages.includes(page)
      const hasDemoMode = DemoPages.includes(page) && matchProps.match.params.demo === 'playfun'
      const TagName = hasDemoMode || (Auth.isAuthenticated() && isMultivewPage) ? layouts.multy : layouts.main

      return (
        <TagName page={page} key={language} isSettingsLoading={isSettingsLoading} alias={alias} hasDemo={hasDemoMode} pageBgData={pageBgData} matchProps={PopupListener.getParams(matchProps)}>
          {(isSettingsLoading || !language) && PlaceHolder ? <PlaceHolder /> :
            <Suspense fallback={PlaceHolder ? <PlaceHolder /> : <></>}>
              {!isSettingsLoading ? (!isMultivewPage ? <Suspense fallback={<div></div>}><NotFound /></Suspense> : <Component hasDemo={hasDemoMode} {
                ...PopupListener.getParams(matchProps)
              } />) : null}
            </Suspense>}
        </TagName>
      )
    }
    } />
  )
};